import React from 'react';
import { Link } from 'react-router-dom';

const steps = [
  {
    title: 'Discover somewhere special',
    description: 'Explore Michelin-starred restaurants by city and keep track of the places you’ve visited.',
  },
  {
    title: 'Find a table with Eatsy Pro',
    description: 'Check availability at the London restaurants we track, or set email alerts for your favourites.',
  },
  {
    title: 'Book and enjoy',
    description: 'Follow the booking link to reserve directly with the restaurant or its booking provider.',
  },
];

const HowItWorks: React.FC = () => (
  <div className="max-w-5xl mx-auto py-6 sm:py-10">
    <h1 className="font-display font-normal tracking-tight text-3xl sm:text-4xl text-ink-900">How it works</h1>
    <p className="mt-4 text-lg text-ink-600">Your next great meal, in three simple steps.</p>
    <ol className="mt-8 grid gap-4 md:grid-cols-3">
      {steps.map((step, index) => (
        <li key={step.title} className="rounded-2xl border border-ink-200 bg-surface p-6">
          <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-brand-50 font-semibold text-brand-700">{index + 1}</span>
          <h2 className="mt-5 font-display text-2xl text-ink-900">{step.title}</h2>
          <p className="mt-3 leading-relaxed text-ink-600">{step.description}</p>
        </li>
      ))}
    </ol>
    <p className="mt-6 text-sm text-ink-500">Availability and alerts update after scheduled checks. Tables can change before you book.</p>
    <Link to="/" className="mt-8 inline-flex rounded-lg bg-brand-600 px-5 py-3 font-medium text-white hover:bg-brand-700">Explore restaurants</Link>
  </div>
);

export default HowItWorks;
